module.exports = __webpack_public_path__ + "img/鹏程杯@2x.ac55f89b.png";